import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {DocumentTemplateService} from '../../../services/document-template.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { SharedService } from '../../../../shared/services';

@Component({
  selector: 'app-document-template-view',
  templateUrl: './document-template-view.component.html',
  styleUrls: ['./document-template-view.component.css']
})
export class DocumentTemplateViewComponent implements OnInit {

  documentTemplateDetail: any;
  tempid: number =0;

  constructor(
    private spinner: NgxSpinnerService,
    private documentTemplateService:DocumentTemplateService,
    private route: ActivatedRoute,private router: Router,
    public sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    this.checkViewPermission();
    this.route.queryParams
      .subscribe(params => {
        console.log(params);
        this.tempid = params.id;
        console.log("id value is "+this.tempid);
      }
    );

    if(this.tempid>0)
    {
      this.getDocumentTemplateDetails();
    }
  }

  checkViewPermission()
   {
     var result = this.sharedService.checkPermission("Admin_View");
     if(!result)
     this.router.navigateByUrl('/login');
   }

   getDocumentTemplateDetails()
  {
      this.documentTemplateService.getDocumentTemplateById(this.tempid).subscribe((data: any) => {
      this.documentTemplateDetail = data;
      console.log('this.documentTemplateDetail');
      console.log(this.documentTemplateDetail);
     });
  }

  cancel()
  {
    this.router.navigate(['/document-template']);
  }

}
